import {ClosingModel} from "./closing-model";
import {BookingType} from "../../../models/payment/booking-type";

export class CashModel {
  private _coins: number | null = null;
  get coins() {
    return this._coins;
  }

  set coins(value: number | null) {
    this._coins = value;
    this.calculate();
  }

  private _rolls: number | null = null;
  get rolls() {
    return this._rolls;
  }

  set rolls(value: number | null) {
    this._rolls = value;
    this.calculate();
  }

  private _bills: number | null = null;
  get bills() {
    return this._bills;
  }

  set bills(value: number | null) {
    this._bills = value;
    this.calculate();
  }

  total: number | null = null;

  private calculate() {
    this.total = (this._coins ?? 0) + (this._rolls ?? 0) + (this._bills ?? 0);
  }

  get used(): number {
    return Math.round(this.closingModels.reduce((acc, cm) => acc + (cm.actual ?? cm.get(BookingType.Cash)), 0) * 100) / 100;
  }

  closingModels: ClosingModel[] = [];

  get hasUnfinished(): boolean {
    return this.closingModels.some(x => !x.success)
  }

  get remaining(): number {
    return (this.total ?? 0) - this.used;
  }
}
